//
//TO APP
//

export const app_start = (endpoint = "", functionKey = "") =>{

    let data = {IsApp:true};

    if(endpoint !== ""){
        data["endpoint"] = endpoint;
    }

    if(functionKey !== ""){
        data["function"] = functionKey;
    }
    CallApp("app_start", data);
};

export const update_app_auth = (token = "", apiKey = "", endpoint = "", functionKey = "") =>{
    let data = {};

    if(endpoint && endpoint !== ""){
        data["endpoint"] = endpoint;
    }

    if(functionKey && functionKey !== ""){
        data["function"] = functionKey;
    }

    if(token && token !== ""){
        data["token"] = token;
    }

    if(apiKey && apiKey !== ""){
        data["apikey"] = apiKey;
    }
    CallApp("update_auth", data);
};

export const session_update = (() => {
  const DEBOUNCE_DELAY = 100; // ms – tweak as needed

  let timeoutId = null;
  let lastArgs = null;

  return (sessionId, setupId, viewonly = false) => {
    // New set of arguments
    const nextArgs = [sessionId, setupId, viewonly];

    // If something is already scheduled, cancel it
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    // Store the latest arguments
    lastArgs = nextArgs;

    // Schedule the call with the newest args
    timeoutId = setTimeout(() => {
      const [sId, stId, v] = lastArgs;

      CallApp("session_update", {
        session_id: sId,
        setup_id: stId,
        view_only: v
      });

      timeoutId = null;
      lastArgs = null;
    }, DEBOUNCE_DELAY);
  };
})();

export const connect_sensor = () => {//for cocoon, tells app to look for a new sensor with new setup clicked
    CallApp("connect_sensor", {newSetup:true});
};

export const disconnect_sensor = () => {//for cocoon, tells app to disconnect from a sensor if one is connected during new setup process and that process is cancelled
    CallApp("disconnect_sensor", {newSetup:true});
};

export const downloadCSV = (csvChunk, isLastChunk) => {
    CallApp("downloadCSV", {chunk:csvChunk, isLastChunk:isLastChunk});
}

export const downloadFile = (fileChunk, isLastChunk, fileName) => {
    CallApp("downloadFile", {chunk:fileChunk, isLastChunk:isLastChunk, fileName:fileName});
}

export const rescan_barcode = () => {
    CallApp("scanBarcode", {scan:true});
}

export const process_toptracer_shots = (type) => {
    CallApp("processShots", {process:true, type:type});
}

function CallApp(message, data){
    try { window.invokeCSharpAction?.('{"messageType": "'+ message +'","payload":' + JSON.stringify(data) + '}');}
      catch(e){console.error(e);}
};